var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOjitoCerrado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 7.5C2.89431 8.28073 3.65286 8.95964 4.5 9.51375M4.5 9.51375C5.41237 10.109 6.43096 10.5228 7.5 10.7325C8.49094 10.9229 9.50906 10.9229 10.5 10.7325C11.569 10.5228 12.5876 10.109 13.5 9.51375M4.5 9.51375L3.375 10.875M15.75 7.5C15.1057 8.28073 14.3471 8.95964 13.5 9.51375M13.5 9.51375L14.625 10.875M7.5 10.7318L7.125 12.375M10.5 10.7318L10.875 12.375",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOjitoCerrado);
export default __webpack_public_path__ + "static/media/ojito_cerrado.51e8819ac48f3e551f25937525d90c09.svg";
export { ForwardRef as ReactComponent };